var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { RemoveSpacesService } from '@/domains/spaces/services/remove-space-service.interface';
import { AbstractSpaceActionService } from '@/services/space-action-service';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@/services/i18n-service';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { ConfirmService } from '@/services/confirm-service.interface';
import { SpaceType } from '@/domains/spaces/enums';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
let RemoveSpaceContribution = class RemoveSpaceContribution extends AbstractSpaceActionService {
    constructor(_logger, _removeSpaceService, _ravenService, _i18nService, _confirmService, _spaceLabelService) {
        super();
        this._logger = _logger;
        this._removeSpaceService = _removeSpaceService;
        this._ravenService = _ravenService;
        this._i18nService = _i18nService;
        this._confirmService = _confirmService;
        this._spaceLabelService = _spaceLabelService;
    }
    async _execute() {
        const { spaceType } = this.currentSpaceService.getCurrentSpace();
        let title = this._i18nService.t('workspace.labels.deleteWorkspace');
        let message = this._i18nService.t('workspace.labels.deleteWorkspaceDesc');
        if (spaceType === SpaceType.Public) {
            title = this._i18nService.t('workspace.labels.deletePubWorkspace');
            message = this._i18nService.t('workspace.labels.deletePubWorkspaceDesc');
        }
        const bool = await this._confirmService.confirm({
            title,
            message,
            description: this._i18nService.t('Readability.deleteTip'),
            confirmText: this._i18nService.t('global.btn.delete'),
            cancelText: this._i18nService.t('global.btn.cancel'),
            type: 'error',
        });
        bool ? this._onConfirmed() : this._onAborted();
    }
    async _onConfirmed() {
        const { spaceId } = this.currentSpaceService.getCurrentSpace();
        await this._removeSpaceService.removeSpaces([spaceId]);
        this._spaceLabelService.resetSpaceLabel();
        this._track([spaceId]);
    }
    _track(spaceIds) {
        if (spaceIds.length > 1) {
            this._ravenService.track('Delete Workspaces', { workspace_id: spaceIds[0] });
        }
        else {
            this._ravenService.track('Batch Delete Workspace', { workspace_ids: spaceIds });
        }
    }
    _onAborted() {
        this._logger.info('Remove Space Aborted');
    }
    registerCommands(commandRegistry) {
        commandRegistry.registerCommand({
            id: 'remove-space',
        }, {
            execute: () => {
                return this._execute();
            },
        });
    }
    registerSpaceActions(spaceActionRegistry) {
        spaceActionRegistry.registerSpaceAction({
            order: 100,
            commandId: 'remove-space',
            label: this._i18nService.t('global.btn.delete'),
            iconClass: 'SolidDelete',
            isEnabled: (space) => {
                if (space.isPublic) {
                    return space.isManager;
                }
                return !space.isShared;
            },
            isVisible: (space) => {
                return !space.isShared;
            },
        });
    }
};
RemoveSpaceContribution = __decorate([
    injectable(),
    __param(0, inject(Logger)),
    __param(1, inject(RemoveSpacesService)),
    __param(2, inject(RavenService)),
    __param(3, inject(I18nService)),
    __param(4, inject(ConfirmService)),
    __param(5, inject(SpaceLabelService)),
    __metadata("design:paramtypes", [typeof (_a = typeof Logger !== "undefined" && Logger) === "function" ? _a : Object, typeof (_b = typeof RemoveSpacesService !== "undefined" && RemoveSpacesService) === "function" ? _b : Object, typeof (_c = typeof RavenService !== "undefined" && RavenService) === "function" ? _c : Object, typeof (_d = typeof I18nService !== "undefined" && I18nService) === "function" ? _d : Object, typeof (_e = typeof ConfirmService !== "undefined" && ConfirmService) === "function" ? _e : Object, typeof (_f = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _f : Object])
], RemoveSpaceContribution);
export { RemoveSpaceContribution };
